import ComposedMail from './ComposedMail';

export default ComposedMail


// WEBPACK FOOTER //
// /src/components/mailThread/mail/composedMail/index.js